// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__3YDBA","left":"sidebar_left__1Y_w3","right":"sidebar_right__uCMsF"};